package com.example.event_management_system.ui.screens.settings

import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.example.event_management_system.data.models.User
import com.example.event_management_system.data.repository.IAuthRepository
import com.example.event_management_system.data.repository.IUserRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class SettingsState(
    val currentUser: User? = null,
    val isLoading: Boolean = true,
    val isLoggingOut: Boolean = false,
    val isLoggedOut: Boolean = false,
    val isSavingPhone: Boolean = false,
    val message: String? = null,
    val error: String? = null
)

class SettingsScreenModel(
    private val authRepository: IAuthRepository,
    private val userRepository: IUserRepository
) : ScreenModel {

    private val _state = MutableStateFlow(SettingsState())
    val state: StateFlow<SettingsState> = _state.asStateFlow()

    init {
        loadUser()
    }

    private fun loadUser() {
        screenModelScope.launch {
            _state.update { it.copy(isLoading = true) }
            val userId = authRepository.getCurrentUserId()
            if (userId != null) {
                val user = userRepository.getUser(userId)
                _state.update { it.copy(currentUser = user, isLoading = false) }
            } else {
                _state.update { it.copy(isLoading = false, error = "Not authenticated") }
            }
        }
    }

    fun clearMessage() {
        _state.update { it.copy(error = null, message = null) }
    }

    fun updatePhone(phone: String) {
        val user = _state.value.currentUser ?: return
        screenModelScope.launch {
            _state.update { it.copy(isSavingPhone = true) }
            try {
                val updated = user.copy(phone = phone.trim().ifBlank { null })
                userRepository.updateUser(user.id, updated)
                _state.update { it.copy(currentUser = updated, isSavingPhone = false, message = "Mobile number saved.") }
            } catch (e: Throwable) {
                _state.update { it.copy(isSavingPhone = false, error = e.message ?: "Failed to save.") }
            }
        }
    }

    fun signOut() {
        screenModelScope.launch {
            _state.update { it.copy(isLoggingOut = true) }
            try {
                authRepository.signOut()
                _state.update { it.copy(isLoggingOut = false, isLoggedOut = true) }
            } catch (e: Throwable) {
                _state.update {
                    it.copy(
                        isLoggingOut = false,
                        error = e.message ?: "Failed to sign out"
                    )
                }
            }
        }
    }
}
